import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AuthApi from "../../api/authApi";
import { toast } from "react-toastify";
import AuthShell from "./AuthShell";
import { trimIfOnChangeField } from "../../utils/trimFormFields";

const ForgotPassword: React.FC = () => {
  let api = new AuthApi();
  let history = useNavigate();
  const [validated, setValidated] = useState<boolean>(false);
  const [data, setData] = useState<Record<string, any>>({
    email: "",
  });

  const handleChanges = async (e: any) => {
    let { name, value } = e.target;
    if (typeof value === "string") value = trimIfOnChangeField(name, value);
    let d = { ...data };
    d[name] = value;
    setData(d);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity()) {
      api
        .TakeEmail(data)
        .then((res: any) => {
          if (res.success) {
            toast.success(res.msg);
            history(`/changePassword`, {
              state: {
                emailaddress: data.email,
              },
            });
          } else {
            toast.error(res.msg);
          }
        })
        .catch((error: any) => {
          console.log(error);
          toast.error(error);
        });
    }
    setValidated(true);
  };

  return (
    <AuthShell
      title="Forgot password?"
      subtitle="Enter your email and we'll send you an OTP to reset your password."
      showBackToLogin
    >
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        className="auth-modern-form"
      >
        <Form.Group className="auth-field">
          <Form.Label>Email</Form.Label>
          <Form.Control
            required
            type="email"
            id="EmailinPut"
            className="form-control form-control-sm border-left-0"
            placeholder="Enter your email"
            name="email"
            value={data.email}
            onChange={(e) => handleChanges(e)}
          />
          <Form.Control.Feedback type="invalid">
            Please provide valid email.
          </Form.Control.Feedback>
        </Form.Group>
        <Button type="submit" className="auth-submit mt-2">
          Send OTP
        </Button>
      </Form>
    </AuthShell>
  );
};

export default ForgotPassword;
